import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderSl = () => {
    return (
        <HighlightedText
            text="PREVZEMI SVOJ BONUS"
            highlights={[{ word: 'SVOJ' }, { word: 'BONUS' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentSl = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 BREZPLAČNIH VRTLJAJEV"
            highlights={[{ word: '325%' }, { word: '+' }, { word: '400' }]}
            breakAfterWords={['Bonus', 'BREZPLAČNIH']}
            className={styles['text_content--FOURTH']}
        />
    )
}
